// src/App.tsx
import React from 'react';
import ABTestInterface from './components/ABTestInterface';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <ABTestInterface />
    </div>
  );
}

export default App;
